module.exports = {
	PRODUCTION_APP_NAME: 'motorway-dealer-webapp',
};
